import { CMS } from "../../components/cms/cms";
import { Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { loadAds, loadCms, setPageTitle, setSubMenu } from "../../app";

type State = {
    isContentReady: boolean;
}
export function HomeIndexPage() {
    const [state, setState] = createStore<State>({ isContentReady: false });
    onMount(async () => {
        const ids = [
            "8th-arc-salon/introduction::page-title",
            "8th-arc-salon/introduction::page-body",
        ];
        await loadCms(ids);
        await loadAds("8th-arc-salon/introduction");
        setSubMenu("Introduction");
        setPageTitle({ id: "8th-arc-salon/introduction::page-title", text: "Introduction" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="text-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9">
                                <CMS id="8th-arc-salon/introduction::page-body">introduction section</CMS>
                            </div>
                        </div>
                    </div>
                </div>
            </Show>           
        </>
    )
}